module.exports = __webpack_public_path__ + "img/block2.f39cb491.webp";